
const Login = () => {
    if (process.env.NODE_ENV === "development") {
        localStorage.setItem('role', '3');
    }
    window.location.href = process.env.REACT_APP_AUTH_LOGIN_ENDPOINT;
    return null;
};

export default Login;
